import { render, staticRenderFns } from "./BreakoutRoomsActions.vue?vue&type=template&id=4478fdea&scoped=true"
import script from "./BreakoutRoomsActions.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsActions.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsActions.vue?vue&type=style&index=0&id=4478fdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478fdea",
  null
  
)

export default component.exports